import { withStyles } from "@mui/styles";

export const createStyled = (styles?:Record<string,any>, options?:any) => {
  const Styled = function (props) {
    const { children, ...other } = props;
    return children(other);
  };

  return withStyles(styles, options)(Styled);
};
